import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { NotificationPanelGroups, UNCLEARABLE_COUNT_TYPES } from '@/models/Notification';
import NotificationPanelItemGroup from '@/components/toolbar/notification/NotificationPanelItemGroup.vue';
import useNotificationState from '@/state/notificationState';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanelItemGroups',
  props: {
  itemGroups: { type: Object as PropType<NotificationPanelGroups>, default: null },
},
  setup(__props) {

const props = __props;

const { clear } = useNotificationState();



const hasOnlyUnclearableCountType = computed(() => props.itemGroups?.groups?.every?.(
  (group) => group.items.every(
    (item) => UNCLEARABLE_COUNT_TYPES.includes(item.countType)
  )
) ?? false);


return { __sfc: true,clear, props, hasOnlyUnclearableCountType, NotificationPanelItemGroup }
}

})